export const FILE_STATUS_VALUES = {
  uploading: 'uploading',
  queued: 'queued',
  analyzing: 'analyzing',
  splitting: 'splitting',
  indexing: 'indexing',
  ready: 'ready',
  failed: 'failed',
} as const;

export type FileStatus =
  (typeof FILE_STATUS_VALUES)[keyof typeof FILE_STATUS_VALUES];

export const FILE_STATUS_LABELS: Record<FileStatus, string> = {
  uploading: 'Uploading',
  queued: 'Uploaded, waiting for processing',
  analyzing: 'Analyzing',
  splitting: 'Splitting',
  indexing: 'Indexing',
  ready: 'Ready',
  failed: 'Failed',
};
